import React from 'react';
import { motion } from 'framer-motion';
export function OpeningLead() {
  return <section className="relative bg-navy-800 py-20 px-4 overflow-hidden" data-id="element-159">
      <div className="section-divider absolute top-0 left-0 right-0" data-id="element-160" />

      {/* Ambient glow */}
      <div className="absolute top-0 right-0 w-64 h-64 rounded-full opacity-5 pointer-events-none" style={{
      background: 'radial-gradient(circle, #c9a84c, transparent)'
    }} data-id="element-161" />

      <div className="max-w-3xl mx-auto" data-id="element-162">
        {/* Time stamp */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-10" data-id="element-163">
          <span className="font-lato text-gold-400 text-5xl font-black tracking-tight opacity-30" data-id="element-164">
            3:14 AM
          </span>
        </motion.div>

        {/* Opening paragraphs */}
        {['Son las 3:14 AM. El silencio de la casa solo es interrumpido por el llanto de tu bebé... y por el latido de tu propio corazón acelerado por la frustración.', 'Te miras al espejo y apenas te reconoces. Las ojeras no son solo estéticas; son el reflejo de una mente que está al límite. Te habían dicho que "ser padres era así", pero nadie te advirtió que la privación del sueño te quitaría la paciencia, la alegría y hasta la conexión con tu pareja.', 'Sientes culpa por desear que la noche pase rápido, y miedo porque sabes que mañana tendrás que funcionar en el trabajo — o en la casa — con el cerebro nublado.'].map((para, i) => <motion.p key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: i * 0.15
      }} className="font-lato text-lg md:text-xl text-cream/80 leading-relaxed mb-6 italic" data-id="element-165">
            {para}
          </motion.p>)}

        {/* Empathy callout */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="mt-10 p-8 rounded-2xl border border-gold-500/40 text-center" style={{
        background: 'linear-gradient(135deg, rgba(201,168,76,0.08), rgba(201,168,76,0.03))'
      }} data-id="element-166">
          <p className="font-playfair text-2xl md:text-3xl font-bold text-gold-300 leading-snug" data-id="element-167">
            "Tengo una noticia para ti:
          </p>
          <p className="font-playfair text-2xl md:text-3xl font-bold text-cream mt-2 leading-snug" data-id="element-168">
            No es tu culpa. Y no tiene por qué ser así."
          </p>
        </motion.div>
      </div>

      <div className="section-divider absolute bottom-0 left-0 right-0" data-id="element-169" />
    </section>;
}